/* ImVita — make product-card images clickable to their detail page.
   Wraps each .pcard .media in a link pointing at the card's "Details" target,
   so clicking the image navigates (while drag-drop photo replacement still works). */
(function () {
  'use strict';
  document.querySelectorAll('.pcard').forEach(function (card) {
    var media = card.querySelector('.media');
    if (!media || media.tagName === 'A') return;
    // find the card's detail destination: first link to an .html page
    var dest = null;
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (dest) return;
      var h = a.getAttribute('href');
      if (h && /\.html(\?|#|$)/.test(h)) dest = h;
    });
    if (!dest) return;
    var a = document.createElement('a');
    a.href = dest;
    a.className = media.className;
    a.setAttribute('aria-label', 'View product details');
    if (media.getAttribute('style')) a.setAttribute('style', media.getAttribute('style'));
    while (media.firstChild) a.appendChild(media.firstChild);
    media.parentNode.replaceChild(a, media);
  });
})();
